import { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { IOpsPortalUuidsToPaymentRefs } from '@schemas/opsPortal/types/uuidsToPaymentRefs';
import { QueryKeys } from '@utils/constants';
import { Endpoints } from '@utils/enums';
import { fetchDataFromEndpoint } from '@utils/fetchDataFromEndpoint/fetchDataFromEndpoint';

export const useUuidsToPaymentRefsQuery = (uuids: string[]) =>
  useQuery<IOpsPortalUuidsToPaymentRefs, AxiosError>(
    [QueryKeys.CONTRACTS_PAYMENT_REFS_RECEIVABLES, uuids.join(',')],
    () =>
      fetchDataFromEndpoint(
        `${Endpoints.FetchContractsPaymentPlanRefsFromUuids}`,
        {
          query: {
            uuids: uuids.join(','),
          },
        },
      ),
    {
      enabled: uuids.length > 0,
    },
  );
